
angular.module('dyb.students.certificates', ['classy', 'dyb.util.forms', 'classy.models']);
